<template>
  <div class="podcast-player is-flex">
    <div v-if="hasPlay" class="play-circle-wrap is-flex">
      <IonIcon
        class="pointer"
        :icon="isPlaying ? pauseCircle : playCircle"
        size="large"
        @click="$emit('toggle-play', $event)"
      />
    </div>
    <div
      v-if="progressSpend !== null && !hideProgress"
      class="player-progress is-flex is-flex-direction-column"
    >
      <AppProgress
        :progress="progressSpend"
        :hasDynamicColors="hasDynamicColors"
      />
      <p v-if="hasLeftHint && timeLeft" class="player-left-time fw-300">
        {{ timeLeft }}
      </p>
    </div>
    <IonIcon
      v-if="hasClose"
      class="pointer"
      :icon="close"
      size="large"
      @click="$emit('close')"
    />
  </div>
</template>

<script>
import { IonIcon, IonProgressBar } from '@ionic/vue';
import { playCircle, pauseCircle, close } from 'ionicons/icons';
import { useI18n } from 'vue-i18n';

import { computed, toRefs } from '@vue/reactivity';
import AppProgress from '@/components/common/AppProgress';

export default {
  name: 'PlayerReproduction',
  components: {
    AppProgress,
    IonIcon,
    IonProgressBar,
  },
  props: {
    duration: {
      type: Number,
      default: 0,
    },
    currentTime: {
      type: Number,
      default: 0,
    },
    isPlaying: {
      type: Boolean,
      default: false,
    },
    hasClose: {
      type: Boolean,
      default: false,
    },
    hasPlay: {
      type: Boolean,
      default: true,
    },
    hasLeftHint: {
      type: Boolean,
      default: true,
    },
    hideProgress: {
      type: Boolean,
      default: false,
    },
    hasDynamicColors: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const { currentTime, duration } = toRefs(props);
    const progressSpend = computed(() => {
      if (
        (!currentTime.value && currentTime.value !== 0) ||
        (!duration.value && duration.value !== 0)
      ) {
        return null;
      }
      const progress = currentTime.value / duration.value;
      return isNaN(progress) ? 0 : progress * 100;
    });

    const minutesLeft = computed(() => {
      const secondsLeft = duration.value - currentTime.value;
      return Math.round(secondsLeft / 60);
    });

    const { t } = useI18n();

    const timeLeft = computed(() => {
      return minutesLeft.value <= 0
        ? t('podcast.played')
        : minutesLeft.value +
            ' ' +
            (currentTime.value > 0 ? t('podcast.minLeft') : t('podcast.min'));
    });
    return {
      playCircle,
      pauseCircle,
      close,
      minutesLeft,
      progressSpend,
      timeLeft,
    };
  },
};
</script>

<style scoped lang="scss">
.podcast-player {
  align-items: center;
}

.podcast-player > *:not(:last-child) {
  margin-right: 10px;
}

.player-progress {
  align-items: flex-end;
  align-self: flex-end;
}

.podcast-player,
.player-progress {
  width: 100%;
}

.play-circle-wrap {
  width: 32px;
}

.player-left-time {
  font-size: 10px;
  line-height: 1.8;
}
</style>
